<template>
  <div class="chart-guide">
    <slider :value="currentPercent" @update="onSliderUpdate"></slider>
  </div>
</template>

<style lang="scss">
.chart-guide {
  position: absolute;
  height: 60px;
  width: 100%;
  z-index: 1;

  .thumb {
    width: 20px;
    height: 100%;
    left: -10px;

    &:after {
      position: absolute;
      content: '';
      width: 2px;
      left: 9px;
      background: #ff9e00;
      height: 100%;
    }
  }
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import Slider from '@/components/Slider'

export default {
  components: {
    Slider
  },

  computed: {
    ...mapGetters([
      'currentPercent'
    ])
  },

  methods: {
    ...mapActions({
      setPercent: 'percentToTrackIdx'
    }),
    onSliderUpdate (value) {
      this.setPercent(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChartGuide.vue?537ce677